import { DrEntity } from './dr-entity';
import { isNullOrUndefined } from './utils';


export class ReefReviewConnector extends DrEntity {
    hostUrl: string;
    remoteHost: string;
    remotePath: string;

    constructor(value?: Partial<ReefReviewConnector>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class ReefReviewConnectorViewModel {
    static hostPortDefaultValue = '25';

    model: Partial<ReefReviewConnector>;
    original: Partial<ReefReviewConnector>;

    constructor(value?: Partial<ReefReviewConnector>) {
        if (value) {
            this.model = value;
        }

        if (this.model) {
            this.original = new ReefReviewConnector(this.model);
        }
    }

    isDirty(): boolean {
        const dirty = false;
        if (this.model.hostUrl !== this.original.hostUrl) {
            return true;
        }

        if (this.model.remoteHost !== this.original.remoteHost) {
            return true;
        }

        if (this.model.remotePath !== this.original.remotePath) {
            return true;
        }
        return dirty;
    }
}
